/* global window */
import $ from 'jquery';

function customScrollBarHeight() {
	$('.custom-scrollbar').each((i, el) => {
		const parent = $(el).parent();
		parent.addClass('custom-scrollbar__parent');
		const parentHeight = $(el).parent().outerHeight();
		const ratio = parentHeight / $(el).prop('scrollHeight');
		const height = (ratio * 300) > $(el).parent().outerHeight() ? (parentHeight / 1.2) : (ratio * 300);
		const styles = { display: 'block', height };
		if (ratio < 1) {
			$(el).next().css(styles);
		} else {
			$(el).next().css('display', 'none');
		}
	});
}
$('.custom-scrollbar').after('<div class="custom-scrollbar__bar-v"></div>');
$(window).bind('load resize', () => {
	customScrollBarHeight();
});

$('.custom-scrollbar').on('scroll', function customScrollBar() {
	const bar = $(this).next();
	const pureHeight = $(this)[0].scrollHeight - $(this).parent().outerHeight();
	const scrollTop = ($(this).scrollTop() / pureHeight) * 100;
	const finalScroll = (($(this).parent().outerHeight() - bar.outerHeight()) / 100) * scrollTop;
	bar.css('transform', `translateY(${finalScroll}px`);
});



// WEBPACK FOOTER //
// ./frontend/js/custom-scrollbar.js